import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "bg-white text-black exam-evaluation-container p-3" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["innerHTML"]

import { computed } from 'vue'
import ExamEvaluation from '../../../api/v2/models/exam_evaluation'
import { checkMobile } from '../../utils/utils'

// Props

export default /*@__PURE__*/_defineComponent({
  __name: 'ExamEvaluation',
  props: {
    examEvaluations: {},
    score: { default: 0 }
  },
  setup(__props: any) {

const props = __props

// Reactive Data
const mobile = checkMobile()

// Computed
const examEvaluation = computed(() => {
  return props.examEvaluations.find((item) => item.to >= props.score && item.from <= props.score)
})

return (_ctx: any,_cache: any) => {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_divider = _resolveComponent("v-divider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(`d-flex ${_unref(mobile) ? 'flex-column' : ''}`)
    }, [
      (examEvaluation.value?.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "evaluation-value",
            style: _normalizeStyle({fontSize: examEvaluation.value.kind == 'normal' ? '3rem' : '1.5rem'})
          }, _toDisplayString(examEvaluation.value.value), 5 /* TEXT, STYLE */))
        : _createCommentVNode("v-if", true),
      _createVNode(_component_v_spacer, {
        class: _normalizeClass(`${_unref(mobile) ? 'my-3' : 'mx-3'}`)
      }, null, 8 /* PROPS */, ["class"]),
      _createElementVNode("div", {
        class: "evaluation-description font-weight-bold py-2",
        innerHTML: examEvaluation.value?.description
      }, null, 8 /* PROPS */, _hoisted_2)
    ], 2 /* CLASS */),
    _createVNode(_component_v_divider, {
      class: _normalizeClass(`mt-0 ${_unref(mobile) ? 'mb-6' : ''}`)
    }, null, 8 /* PROPS */, ["class"]),
    _createElementVNode("div", {
      innerHTML: examEvaluation.value?.body
    }, null, 8 /* PROPS */, _hoisted_3)
  ]))
}
}

})